import React, { useState, useEffect, useRef, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfigurationReportTab from './configurationTab';
import Sorting from '../../components/company_panel/common/sorting';
import { capitalizeFirstLetter, formateDate, formateDateWithTime, getBrandId, getCompany, getOutletId, TrimText } from '../../helpers/commonFunctions';
import CustomPagination from '../../components/company_panel/common/custompagination';
import Loader from '../../components/company_panel/common/loader';
import notFound from '../../../src/assets/company/img/no-record-found.png'
import CustomRangepicker from '../../components/company_panel/common/rangepicker';
import { ListPaymentReport, ListSalesReport } from '../../services/company_panel/report.services';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { LOADER_TIME } from '../../utils/Constants';
import { GetActiveOrderModes } from '../../services/company_panel/setting/orderModeConfigurationService';
import $ from "jquery";
import CustomModal from '../../components/company_panel/common/customModal';
import { GetAllPaymentMethods } from '../../services/company_panel/setting/tenderConfigurationService';
import { lastBusinessDate } from '../../services/company_panel/outletService';
import Swal from 'sweetalert2';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { faL } from '@fortawesome/free-solid-svg-icons';


const PaymentReportList = () => {

    const breadcrumbs = [{ title: "Dashboard", url: "/company/dashboard" }, { title: "Pages", url: "" },]
    
    const [list, setList] = useState([])
    const [dataLength, setDataLength] = useState()
    const [totalAmount, setTotalAmount] = useState();
    const [totalOrders, setTotalOrders] = useState();

    const [itemPerPage, setItemPerPage] = useState(10)
    const [sorting, setSorting] = useState({});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState({})
    const [globalSearch, setGlobalSearch] = useState("")
    const [resetdate, setResetDate] = useState(false);

    const selectRef = useRef(null);
    const [orderType, setOrderType] = useState();
    const [modalData, setModalData] = useState([]);

    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    const paymentTypes = ['cash', 'card', 'credit', 'online'];
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [dateFilterValue, setDateFilterValue] = useState([]);
    const [businessDateFilterValue, setBusinessDateFilterValue] = useState([]);
    const [businessDate, setBusinessDate] = useState({});


    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setIsOutletChanged(!isOutletChanged);
        })

    });

    useEffect(() => {
        GetAllPaymentMethods({ brand_id: getBrandId() })
            .then(response => {
                const data = response.data.response;
                setPaymentMethods(data);
            })
            .catch(error => {
                console.log(error);
            })
    }, [])

    useEffect(() => {
        const getData = setTimeout(() => {
            if (search) {
                setLoader(true)
                setTimeout(() => {
                    const formData = new FormData()
                    formData.append("page", page)
                    formData.append("per_page", itemPerPage)
                    formData.append("sort", JSON.stringify(sorting))
                    formData.append("search", JSON.stringify(search))
                    formData.append("global_search", globalSearch)
                    formData.append('company_id', getCompany().company_id);
                    formData.append('brand_id', getBrandId());
                    formData.append('outlet_id', getOutletId());
                    ListPaymentReport(formData).then(data => {
                        setDataLength(data?.data?.response?.count || 0);
                        setList(data?.data?.response?.rows || []);
                        setTotalAmount(data?.data?.response?.total_amount || 0)
                        setTotalOrders(data?.data?.response?.total_orders || 0)
                        setLoader(false);
                    }).catch(error => {
                        console.log("error ====> ", error);
                        setList([]);
                        setDataLength(0);
                        setTotalAmount(0);
                        setTotalOrders(0);
                        Swal.fire({
                            customClass: 'swal-wide',
                            position: 'absolute',
                            icon: 'error',
                            title: error?.response?.data?.errors?.message || error?.message,
                            showConfirmButton: false,
                            timer: 1000,
                            toast: true,
                            position: 'top-right',
                        })
                        setLoader(false);
                    })
                }, 500);
            }
        }, 300);
        return () => clearTimeout(getData);
    }, [sorting, search, globalSearch, page, isBrandChanged, isOutletChanged])

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }

        if (key == 'business_date') {
            setDateFilterValue([]);
            delete sr['created'];
        } else if (key == 'created') {
            setBusinessDateFilterValue([])
            delete sr['business_date'];
        }
        setSearch(sr);
    }

    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        prepareSearch()
        setSearch({})
        setResetDate(!resetdate)
        // $("#defaultstatus")[0].selectedIndex = 0
        $("#resetFilter")[0].selectedIndex = 0
        $("#typeFilter")[0].selectedIndex = 0
    }


    const generateOrderId = (orderId) => {
        let id = orderId;
        let countOfDigits = 0;
        while (id) {
            id = Math.floor(id / 10);
            countOfDigits += 1;
        }

        if (countOfDigits >= 4) {
            return orderId
        }
        let zerosCount = 4 - countOfDigits;
        let generatedZeros = '';
        while (zerosCount) {
            generatedZeros += '0';
            zerosCount -= 1;
        }
        return `${generatedZeros}${orderId}`;
    }

    const getOrderItemsNames1 = (data) => {
        return data && data.menu_items
            ? data.menu_items.join(', ') // Join all menu items into a single comma-separated string
            : 'N/A'; // Return 'N/A' if there are no menu items
    };



    const headerMapping = {
        "payment_method": "Payment Method",
        "payment_type": "Payment Type",
        "total_amount": "Total Amount",
        "total_orders": "Total Orders"
    };

    const handleExport = () => {
         setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('company_id', getCompany().company_id);
        formData.append('brand_id', getBrandId());
        formData.append('outlet_id', getOutletId());

        ListPaymentReport(formData).then(data => {
            setDataLength(data.data.response.count);
            const groups = data && data.data && data.data.response ? data.data.response.rows : [];
            const grandTotalAmount = data?.data?.response?.total_amount || 0;
            const grandTotalOrders = data?.data?.response?.total_orders || 0;

            const printData = [];
            // Global totals at the top-right
            printData.push({ "Payment Method": '', "Payment Type": '', "Total Amount": `Grand Total Amount: ${Number(grandTotalAmount).toFixed(2)}`, "Total Orders": `Grand Total Orders: ${grandTotalOrders}` });
            printData.push({}); // blank row after global totals
            groups.forEach((group) => {
                // Date header in column A (top-left)
                printData.push({ "Payment Method": `Business Date: ${formateDate(group.business_date)}` });

                group.rows.forEach((item) => {
                    printData.push({
                        "Payment Method": capitalizeFirstLetter(item.payment_method),
                        "Payment Type": capitalizeFirstLetter(item.tender_name),
                        "Total Amount": Number(item.total_amount).toFixed(2),
                        "Total Orders": item.total_orders,
                    });
                });

                // Subtotal row per date
                printData.push({ "Payment Method": '', "Payment Type": '', "Total Amount": `Total Amount: ${Number(group.total_amount).toFixed(2)}`, "Total Orders": `Total Orders: ${group.total_orders}` });
                printData.push({}); // blank row after global totals
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = [
                { wch: 25 }, // Payment Method
                { wch: 20 }, // Payment Type
                { wch: 35 }, // Total Amount
                { wch: 25 }, // Total Orders
            ];
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Payment-Report.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
             setGlobalLoader(false);
        }).catch(error => {
            console.log("error ====> ", error);
            Swal.fire({
                customClass: 'swal-wide',
                position: 'absolute',
                icon: 'error',
                title: error?.response?.data?.errors?.message || error?.message,
                showConfirmButton: false,
                timer: 1000,
                toast: true,
                position: 'top-right',
            })
            // setLoader(false);
             setGlobalLoader(false);
        })
    };

    // const getOrderItemsNames = (data) => {
    //     return data && (
    //         <div className="d-flex flex-wrap">
    //             {data.menu_items?.map((menuItems, index) => (
    //                 <span key={index} className="mx-1 text-capitalize">
    //                     {menuItems}
    //                     {index < data.menu_items.length - 1 && ', '}
    //                 </span>
    //             ))}
    //         </div>
    //     );
    // };

    const getOrderItemsNames = (data) => {
        return data && (
            <div className="d-flex flex-wrap">
                {data?.menu_items?.slice(0, 2).map((menuItems, index) => (
                    <span key={index} className="mx-1 text-capitalize">
                        {menuItems}
                        {index < data?.menu_items?.length - 1 && ', '}
                    </span>
                ))}
                {data?.menu_items.length > 2 &&
                    <span
                        className="link-text cp"
                        data-bs-target="#exampleModalToggle"
                        data-bs-toggle="modal"
                        onClick={() => setModalData(data.menu_items)}
                    >
                        ...
                    </span>
                }
            </div>
        );
    };

    const filterPaymentType = (e) => {
        if (e?.target.value) {
            prepareSearch("payment_type", e.target.value);
        } else {
            prepareSearch("payment_type", "");
        }
    };
    const filterPaymentMethod = (e) => {
        if (e?.target.value) {
            prepareSearch("payment_method", e.target.value);
        } else {
            prepareSearch("payment_method", "");
        }
    };
    // useEffect(() => {
    //     GetActiveOrderModes(getBrandId()).then(data => {
    //         setOrderType(data && data.data && data.data.response ? data.data.response : []);
    //     }).catch(error => {
    //         console.log("error=====>", error)
    //     })
    // }, [isBrandChanged])

    useEffect(() => {
        const formData = new FormData();
        formData.append('outlet_id', getOutletId());
        lastBusinessDate(formData).then(data => {
            const fetchedBusinessDates = data?.data?.response || [];
            // const formattedBusinessDate = fetchedBusinessDates.business_date ? new Date(fetchedBusinessDates.business_date).toISOString().split('T')[0] : '';

            const businessDate = new Date(fetchedBusinessDates.business_date);
            const year = businessDate.getFullYear();
            const month = String(businessDate.getMonth() + 1).padStart(2, '0');
            const day = String(businessDate.getDate()).padStart(2, '0');
            const formattedBusinessDate = `${year}-${month}-${day}`;

            if (formattedBusinessDate) {
                setBusinessDate(formattedBusinessDate);
            } else {
                setBusinessDate('');
            }
        }).catch(error => {
            console.log("Error fetching business dates:", error);
        });
    }, [isOutletChanged]);

    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Report</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0} className="btn btn-primary ms-2">Export Report</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20 border-bottom'>
                        <div className='col-12'>
                            <div className='d-flex justify-content-between align-items-center'>
                                <ConfigurationReportTab tab='payment' />
                            </div>
                        </div>
                    </div>
                    <div className="gap-20">
                        <div className='page-header d-flex align-items-center mb-0'>
                            {/* <div className='page-header-left'></div> */}
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='page-header-right ms-auto'>
                                <div className='d-flex gap-3 align-items-center'>
                                    <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            {/* <div className="select-down-arrow"> */}
                                            <select
                                                // ref={selectRef}
                                                className={`form-control cp ${orderType && orderType.length > 5 ? 'scrollable-select' : ''}`}
                                                onChange={filterPaymentMethod}
                                                id="resetFilter"
                                            >
                                                <option value="">Payment method</option>
                                                {paymentMethods &&
                                                    paymentMethods?.length > 0 &&
                                                    paymentMethods?.map((method, i) => {
                                                        return (
                                                            <option key={i} value={method.id}>
                                                                {capitalizeFirstLetter(method.name)}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                            {/* </div> */}


                                        </div>
                                    </div>
                                    <div className="me-3">
                                        <div className="form-group mb-0 filter_icon_container filter_design">
                                            {/* <div className="select-down-arrow"> */}
                                            <select
                                                // ref={selectRef}
                                                className={`form-control cp ${orderType && orderType.length > 5 ? 'scrollable-select' : ''}`}
                                                onChange={filterPaymentType}
                                                id="typeFilter"
                                            >
                                                <option value="">Payment Type</option>
                                                {paymentTypes &&
                                                    paymentTypes?.length > 0 &&
                                                    paymentTypes?.map((method, i) => {
                                                        return (
                                                            <option key={i} value={method}>
                                                                {capitalizeFirstLetter(method)}
                                                            </option>
                                                        );
                                                    })}
                                            </select>
                                            {/* </div> */}


                                        </div>
                                    </div>
                                    <div className="date-input">
                                        Business Date
                                        <CustomRangepicker business_date={true} value={businessDateFilterValue} GetDateRange={(e) => { prepareSearch("business_date", e) }} 
                                        resetdate={resetdate} maxDate={businessDate} />
                                    </div>
                                    <div className="date-input">
                                        Date
                                        <CustomRangepicker value={dateFilterValue} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                    </div>
                                    <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {(totalAmount || totalOrders) ? (
                        <div className="d-flex gap-4 px-3 py-2 justify-content-end border-bottom">
                            <b>Grand Total Amount: {Number(totalAmount).toFixed(2)}</b>
                            <b>Grand Total Orders: {totalOrders}</b>
                        </div>
                    ) : null}
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>


                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Payment Method</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="payment_method" />
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Payment Type</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="payment_type" />
                                            </div>
                                        </th>
                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Total Amount</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="total_amount" />
                                            </div>
                                        </th>

                                        <th width="5%">
                                            <div className='sorting_column'>
                                                <span>Total Orders</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="total_orders" />
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                  {
                                    loader ? (
                                        <tr>
                                        <td colSpan={4}>
                                            <Loader />
                                        </td>
                                        </tr>
                                    ) : list?.length ? (
                                        <>
                                        {list.map((group, gi) => (
                                            <React.Fragment key={gi}>
                                                {/* Spacer row before each group */}
                                                <tr><td colSpan={4}>&nbsp;</td></tr>
                                                {/* Business date header row */}
                                                <tr style={{ backgroundColor: '#f0f0f0' }}>
                                                    <td colSpan={4}><strong>Business Date: {formateDate(group.business_date)}</strong></td>
                                                </tr>
                                                {group.rows.map((row, i) => (
                                                    <tr key={i}>
                                                        <td>{capitalizeFirstLetter(row?.tender_name)}</td>
                                                        <td>{capitalizeFirstLetter(row?.payment_method)}</td>
                                                        <td>{Number(row?.total_amount).toFixed(2)}</td>
                                                        <td>{row?.total_orders}</td>
                                                    </tr>
                                                ))}
                                                {/* Subtotal row per date */}
                                                <tr style={{ backgroundColor: '#fafafa' }}>
                                                    <td>&nbsp;</td>
                                                    <td>&nbsp;</td>
                                                    <td><strong>Total Amount: {Number(group.total_amount).toFixed(2)}</strong></td>
                                                    <td><strong>Total Orders: {group.total_orders}</strong></td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                        </>
                                    ) : (
                                        <tr>
                                        <td colSpan={4} className="text-center">
                                            <img
                                            src={notFound}
                                            style={{ width: "5%" }}
                                            alt="Not Found"
                                            />
                                            <p>No record found</p>
                                        </td>
                                        </tr>
                                    )
                                    }

                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "report", path: "/company/report/payment_report/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer
                    position="top-right"
                    hideProgressBar={false}
                    autoClose={true | 1000}
                    newestOnTop={true}
                    closeOnClick={false}
                    draggable={false}
                    rtl={false}
                />
            </div>

            {/* Modal */}

            <CustomModal title={"Order Items"} content={modalData} />
        </>
    );
}

export default PaymentReportList